import React from 'react';
import GieCard from '../../components/GIECard/GieCard';
import GIELink from "../../components/GIELink/GIELink";

export default class CardHome extends React.Component<any, any> {
  render() {
    return (
      <GieCard height="100%" width="100%" clickable={!this.props.notClickable}>
        <a href={this.props.url} className="text-decoration-none" target={this.props.target ?? "_self"}>
          <div className="w-100 h-100 py-3 d-flex align-items-center gap-3 d-md-block text-md-center">
            {this.props.icon}
            <div>
              <div className="card-title-container">
                <div className="first-title">
                  {this.props.firstTitle}
                </div>
                {this.props.secondTitle && <div className="second-title">
                  {this.props.secondTitle}
                </div>}
                {this.props.children}
              </div>
              {!this.props.hideLink &&
                  <GIELink arrowAfter href={this.props.url} className="fw-bold fs-5">
                    {this.props.link}
                  </GIELink>}
            </div>
          </div>
        </a>
      </GieCard>
    )
  }
}
